// @flow

const breakpoints = {
  keys: ['xs', 'sm', 'md', 'lg', 'xl'],
  values: {
    xs: 0,
    sm: 600,
    md: 1025,
    lg: 1280,
    xl: 1920
  }
};

export default breakpoints;
